import { sprintf } from 'sprintf-js';
const _ = importLib('lodash');
const M = importLib('moment');
const Vuex = importLib('vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

export default {
    computed: {
        ...Vuex.mapGetters({
            customer: 'customer',
        }),

        loggedIn() {
            return _.get(this.customer, 'attributes.registered');
        },

        _() {
            return _;
        },

        api() {
            return api;
        },
    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        displayUnitByType(val, trueType, falseType) {
            return val ? trueType : falseType;
        },

        displayDeadLoadDeflection(val, first = false) {
            return this.displayDoubleToDecimalPlace(val, 2);
        },

        displayDoubleToDecimalPlace(val, dec = 2) {
            switch (_.toLower(val)) {
                case 'inf':
                    return Infinity;
                case '-inf':
                    return -Infinity;
                case 'nan':
                    return NaN;
            }

            return parseFloat(val).toFixed(dec);
        },

        displayDoubleToDecimalPlaceNoRound(val, dec = 2) {
            switch (_.toLower(val)) {
                case 'inf':
                    return Infinity;
                case '-inf':
                    return -Infinity;
                case 'nan':
                    return NaN;
            }

            let value = _.parseInt(val * (10 ** dec)) / (10 ** dec);
            return value.toFixed(dec);
        },

        displayFormatByUnit(isMetric, val) {
            if (isMetric) {
                return _.replace(val.toExponential(2), 'e+', 'E+');
            }

            return this.displayDoubleToDecimalPlace(val, 2);
        },

        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },

        scrollTo(elm) {
            let element = document.getElementById(elm);
            element.scrollIntoView({ behavior: "smooth" });
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/components/UtilsMixin.js